import { useTranslation } from 'react-i18next';

import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/utils/utils';

const SKELETON_LINE_WIDTHS = [
  'w-full',
  'w-full',
  'w-[90%]',
  'w-full',
  'w-[85%]',
  'w-full',
  'w-[92%]',
  'w-full',
  'w-[88%]',
  'w-full',
];

export function NarrativeExampleSkeleton({ className }: { className?: string | undefined }) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex max-h-[280px] w-full shrink-0 flex-col rounded-[16px] border border-border-subtle bg-back-bg2 p-3 shadow-none transition-[max-height,opacity,saturate] duration-300 ease-out',
        'animate-fadeIn opacity-100 saturate-100',
        className,
      )}
    >
      {/* Header - Never scrolls */}
      <div className="mb-2 flex shrink-0 items-center justify-between">
        <h3 className="text-foreground font-['Inter'] text-[12px] leading-[160%] font-semibold tracking-normal">
          {t('profile.example.title')}
        </h3>
        <div className="flex items-center gap-1.5">
          <Skeleton className="h-4 w-4 rounded-sm" />
          <Skeleton className="h-4 w-4 rounded-sm" />
          <Skeleton className="h-4 w-4 rounded-sm" />
        </div>
      </div>

      {/* Content Skeleton - Scrollable area with prominent animation */}
      <div className="custom-scrollbar min-h-0 flex-1 space-y-2 overflow-y-auto">
        {SKELETON_LINE_WIDTHS.map((width, index) => (
          <Skeleton
            className={cn(
              'h-4 animate-pulse bg-gradient-to-r from-elevated-subtle via-back-bg2 to-elevated-subtle',
              width,
            )}
            key={index}
          />
        ))}
      </div>
    </div>
  );
}
